<script lang="ts" setup>
defineProps({
    isSolid: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <svg
        v-if="isSolid"
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M15.049 3.78524c.322-.58.113-1.312-.466-1.634-.58-.322-1.31-.113-1.632.467L12 4.33124l-.951-1.713c-.322-.58-1.052-.789-1.632-.467-.579.322-.788 1.054-.466 1.634l1.676 3.019L4 19.5982h-.8c-.663 0-1.2.538-1.2 1.201s.537 1.201 1.2 1.201h17.6c.663 0 1.2-.538 1.2-1.201s-.537-1.201-1.2-1.201H20L13.373 6.80424l1.676-3.019ZM9 19.9982l1.629-4.075c.224-.561.767-.929 1.371-.929s1.147.368 1.371.929L15 19.9982H9Z"
            clip-rule="evenodd"
        />
    </svg>

    <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="m14.874 3.486-1.73 3.11401L20.588 20H21c.552 0 1 .448 1 1s-.448 1-1 1H3c-.552 0-1-.448-1-1s.448-1 1-1h.41199L10.856 6.60001 9.12601 3.486c-.268-.483-.094-1.09199.388-1.35999.483-.268 1.09199-.094 1.35999.388L12 4.54099l1.126-2.02698c.268-.482.877-.656 1.36-.388.482.268.656.87699.388 1.35999ZM10.387 20h3.226l-1.245-3.735C12.315 16.107 12.167 16 12 16c-.167 0-.315.107-.367.265L10.387 20Zm-4.68699 0h2.57898l1.45603-4.368C10.06 14.658 10.972 14 12 14s1.94.658 2.265 1.632L15.721 20h2.58L12 8.659 5.70001 20Z"
            clip-rule="evenodd"
        />
    </svg>
</template>
